"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnum = exports.CompatibleOrdering = exports.queryResultToPaginationResponse = exports.PaginationRequest = exports.PaginationResponse = void 0;
const class_validator_1 = require("class-validator");
let PaginationResponse = (() => {
    class PaginationResponse {
    }
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PaginationResponse.prototype, "total", void 0);
    return PaginationResponse;
})();
exports.PaginationResponse = PaginationResponse;
let PaginationRequest = (() => {
    class PaginationRequest {
    }
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], PaginationRequest.prototype, "take", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], PaginationRequest.prototype, "skip", void 0);
    return PaginationRequest;
})();
exports.PaginationRequest = PaginationRequest;
exports.queryResultToPaginationResponse = (result) => ({
    data: result[0],
    total: result[1]
});
function CompatibleOrdering(property, validationOptions) {
    return (object, propertyName) => {
        class_validator_1.registerDecorator({
            name: "CompatibleOrdering",
            target: object.constructor,
            propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    return !Object.keys(value).some(k => !isEnum(k, property));
                }
            }
        });
    };
}
exports.CompatibleOrdering = CompatibleOrdering;
function isEnum(value, entity) {
    const enumValues = Object.keys(entity).map(k => entity[k]);
    return enumValues.indexOf(value) >= 0;
}
exports.isEnum = isEnum;
//# sourceMappingURL=Pagination.js.map